<template>
  <div>
    <b-overlay :show="loading" no-wrap />
    <validation-observer ref="form">
      <b-form>
        <b-row cols="1">
          <!-- input name -->
          <b-col>
            <b-form-group>
              <validation-provider #default="{ errors }" name="title" rules="required">
                <label for="title">
                  ชื่อรูปวอลเปเปอร์
                </label>
                <small v-if="translationTabKey === 'th'" class="text-danger"> *จำเป็นต้องระบุ</small>
                <small v-else> (ถ้าไม่ระบุ จะแปลให้โดยอัตโนมัติ)</small>

                <b-form-input
                  id="title"
                  v-model="wallpaperDatas.mainImage.title_translations[translationTabKey]"
                  :state="errors.length > 0 ? false : null"
                  type="text"
                  placeholder="ระบุชื่อรูปวอลเปเปอร์"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageTitle'](translationTabKey)">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : ชื่อรูปวอลเปเปอร์
                  </b-badge>
                </label>

                <b-form-input
                  v-model="wallpaperDatas.mainImage.oldTitleTranslations[translationTabKey]"
                  type="text"
                  :disabled="true"
                />
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- input detail -->
          <b-col>
            <b-form-group>
              <validation-provider #default="{ errors }" name="details" rules="required">
                <label for="details">รายละเอียดวอลเปเปอร์</label>
                <small v-if="translationTabKey === 'th'" class="text-danger"> *จำเป็นต้องระบุ</small>
                <small v-else> (ถ้าไม่ระบุ จะแปลให้โดยอัตโนมัติ)</small>
                <b-form-textarea
                  id="details"
                  v-model="wallpaperDatas.mainImage.details_translations[translationTabKey]"
                  :state="errors.length > 0 ? false : null"
                  type="text"
                  placeholder="ระบุรายละเอียดวอลเปเปอร์"
                  :disabled="true"
                  rows="4"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageDetails'](translationTabKey)">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม ซ รายละเอียดวอลเปเปอร์
                  </b-badge>
                </label>

                <b-form-textarea
                  v-model="wallpaperDatas.mainImage.oldDetailsTranslations[translationTabKey]"
                  type="text"
                  rows="4"
                  :disabled="true"
                />
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- input hint free modal -->
          <b-col>
            <b-form-group>
              <validation-provider #default="{ errors }" name="hint_modal_free_image">
                <label for="hint_modal_free_image">เงื่อนไขการใช้วอลเปเปอร์ฟรี (ไม่จำเป็น)</label>
                <small v-if="translationTabKey !== 'th'"> (ถ้าไม่ระบุ จะแปลให้โดยอัตโนมัติ)</small>
                <b-form-textarea
                  id="hint_modal_free_image"
                  v-model="wallpaperDatas.mainImage.hint_modal_free_image_translations[translationTabKey]"
                  :state="errors.length > 0 ? false : null"
                  type="text"
                  rows="2"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div v-if="$store.getters['wallpapers/isEditMainImageHintModalFreeImage'](translationTabKey)">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : เงื่อนไขการใช้วอลเปเปอร์ฟรี
                  </b-badge>
                </label>

                <b-form-textarea
                  v-model="wallpaperDatas.mainImage.oldHintModalFreeImageTranslations[translationTabKey]"
                  type="text"
                  rows="2"
                  :disabled="true"
                />
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- radio hide in store -->
          <b-col>
            <b-form-group label="รูปแบบการขาย" label-for="hide_in_store">
              <div class="px-1">
                <b-form-radio
                  v-model="wallpaperDatas.mainImage.hide_in_store"
                  name="hide_in_store"
                  :value="false"
                  class="mb-50"
                  disabled
                >
                  แสดงในแอปและเว็บ <small>(สามารถใช้ Redeem หรือ Coin เพื่อสร้างรูปวอลเปเปอร์ได้)</small>
                </b-form-radio>
                <b-form-radio
                  v-model="wallpaperDatas.mainImage.hide_in_store"
                  name="hide_in_store"
                  :value="true"
                  disabled
                >
                  ไม่แสดงในแอปและเว็บ <small>(สามารถใช้ Redeem เพื่อสร้างรูปวอลเปเปอร์ได้เท่านั้น)</small>
                </b-form-radio>
              </div>
            </b-form-group>

            <div v-if="$store.getters['wallpapers/isEditMainImageHideInStore']">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : รูปแบบการขาย
                  </b-badge>
                </label>
                <div class="px-1">
                  <b-form-radio
                    v-model="wallpaperDatas.mainImage.oldHideInStore"
                    name="old_hide_in_store"
                    :value="false"
                    class="mb-50"
                    disabled
                  >
                    แสดงในแอปและเว็บ <small>(สามารถใช้ Redeem หรือ Coin เพื่อสร้างรูปวอลเปเปอร์ได้)</small>
                  </b-form-radio>
                  <b-form-radio
                    v-model="wallpaperDatas.mainImage.oldHideInStore"
                    name="old_hide_in_store"
                    :value="true"
                    disabled
                  >
                    ไม่แสดงในแอปและเว็บ <small>(สามารถใช้ Redeem เพื่อสร้างรูปวอลเปเปอร์ได้เท่านั้น)</small>
                  </b-form-radio>
                </div>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select multiple tag -->
          <b-col>
            <b-form-group label="หมวดหมู่วอลเปเปอร์" label-for="wallpaper_tags">
              <b-overlay show :opacity="$store.state.appConfig.layout.skin === 'dark' ? 0 : 0.12" variant="dark">
                <v-select v-model="wallpaperDatas.mainImage.wallpaper_tags" label="tag_name" multiple :options="[]" />
                <template #overlay>
                  <div></div>
                </template>
              </b-overlay>
            </b-form-group>

            <div v-show="$store.getters['wallpapers/isEditMainImageWallpaperTags']">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : หมวดหมู่วอลเปเปอร์
                  </b-badge>
                </label>
                <b-overlay show :opacity="$store.state.appConfig.layout.skin === 'dark' ? 0 : 0.12" variant="dark">
                  <v-select
                    v-model="wallpaperDatas.mainImage.oldWallpaperTags"
                    label="tag_name"
                    multiple
                    :options="[]"
                  />
                  <template #overlay>
                    <div></div>
                  </template>
                </b-overlay>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- Af settings -->
          <b-col cols="12">
            <b-form-group label="เข้าร่วม Affiliate หรือไม่">
              <b-form-radio-group
                v-model="wallpaperDatas.mainImage.affiliate.join_status"
                :options="optionJoinAffiliate"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col v-if="wallpaperDatas.mainImage.affiliate.join_status" sm="12">
            <validation-provider
              #default="{ errors }"
              name="commission_rate"
              rules="required|min_value:0.01|decimal:2|max_value:10"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label for="commission_rate">
                  อัตราค่าคอมมิชชั่น Affiliate (%)
                </label>
                <b-input-group append="%">
                  <b-form-input
                    v-model="wallpaperDatas.mainImage.affiliate.commission_rate"
                    :state="errors.length > 0 ? false : null"
                    type="number"
                    number
                    disabled
                  />
                </b-input-group>
                <b-btn size="sm" variant="primary" class="mt-50" @click="onClickMoreDetailsAllSubWallpaperPriceAF">
                  ดูสรุปรายได้รูปทั้งหมด
                </b-btn>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col v-if="$store.getters['wallpapers/isEditMainImageAffiliateJoinStatus']" cols="12">
            <b-form-group>
              <label>
                <b-badge variant="danger">
                  ข้อมูลเดิม : เข้าร่วม Affiliate หรือไม่
                </b-badge>
              </label>
              <b-form-radio-group
                v-model="wallpaperDatas.mainImage.oldAffiliate.join_status"
                :options="optionJoinAffiliate"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="
              wallpaperDatas.mainImage.affiliate.join_status &&
                $store.getters['wallpapers/isEditMainImageAffiliateCommissionRate']
            "
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="commission_rate"
              rules="required|min_value:0.01|decimal:2|max_value:10"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label for="commission_rate">
                  <b-badge variant="danger">
                    ข้อมูลเดิม : อัตราค่าคอมมิชชั่น Affiliate (%)
                  </b-badge>
                </label>
                <b-input-group append="%">
                  <b-form-input
                    v-model="wallpaperDatas.mainImage.oldAffiliate.commission_rate"
                    :state="errors.length > 0 ? false : null"
                    type="number"
                    number
                    disabled
                  />
                </b-input-group>

                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- input youtube link -->
          <b-col>
            <b-form-group label="ลิงค์ Youtube (ไม่จำเป็น)" label-for="youtube_link">
              <validation-provider #default="{ errors }" name="youtube_link" rules="url">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="YoutubeIcon" class="text-danger" />
                  </b-input-group-prepend>
                  <b-form-input v-model="wallpaperDatas.mainImage.youtube_link" type="text" disabled />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageYouTubeLink']">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : ลิงค์ Youtube
                  </b-badge>
                </label>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="YoutubeIcon" class="text-danger" />
                  </b-input-group-prepend>
                  <b-form-input v-model="wallpaperDatas.mainImage.oldYoutubeLink" type="text" disabled />
                </b-input-group>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- input blog link -->
          <b-col>
            <b-form-group label="ลิงค์ เนื้อหาเพิ่มเติมของวอลเปเปอร์ (ไม่จำเป็น)" label-for="blog_link">
              <validation-provider #default="{ errors }" name="blog_link" rules="url">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="GlobeIcon" class="text-primary" />
                  </b-input-group-prepend>
                  <b-form-input v-model="wallpaperDatas.mainImage.blog_link" type="text" disabled />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageBlogLink']">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : ลิงค์ เนื้อหาเพิ่มเติมของวอลเปเปอร์
                  </b-badge>
                </label>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="GlobeIcon" class="text-primary" />
                  </b-input-group-prepend>
                  <b-form-input v-model="wallpaperDatas.mainImage.oldBlogLink" type="text" disabled />
                </b-input-group>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select zodiac -->
          <b-col md="12">
            <b-form-group label="ราศี" label-for="zodiac">
              <v-select v-model="wallpaperDatas.mainImage.zodiac" label="name" :options="options" :disabled="true" />
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageZodiac']">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : ราศี
                  </b-badge>
                </label>
                <v-select
                  v-model="wallpaperDatas.mainImage.oldZodiac"
                  label="name"
                  :options="options"
                  :disabled="true"
                />
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select font family TH -->
          <b-col md="6">
            <b-form-group label="เลือกฟ้อน TH" label-for="fontFamilyTH">
              <v-select
                v-model="wallpaperDatas.mainImage.optionsFont.TH.name"
                :options="optionsFontNameTH"
                label="family"
                :style="{ 'font-family': _fontActiveTH }"
                :disabled="true"
              >
                <template v-slot:option="option">
                  <span :class="option.icon"></span>
                  <div :style="{ 'font-family': option.family }">{{ option.family }}</div>
                </template>
              </v-select>
            </b-form-group>

            <div v-if="$store.getters['wallpapers/isEditMainImageOptionsFontFamily']('TH')">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : เลือกฟ้อน TH
                  </b-badge>
                </label>
                <v-select
                  v-model="wallpaperDatas.mainImage.oldOptionsFont.TH.name"
                  :options="optionsFontNameTH"
                  label="family"
                  :style="{ 'font-family': _fontActiveTH }"
                  :disabled="true"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon"></span>
                    <div :style="{ 'font-family': option.family }">{{ option.family }}</div>
                  </template>
                </v-select>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select font style TH -->
          <b-col md="6">
            <b-form-group label="เลือกสไตล์ฟ้อน TH" label-for="fontStyleTH">
              <v-select
                v-model="wallpaperDatas.mainImage.optionsFont.TH.style"
                label="font"
                :options="wallpaperDatas.mainImage.optionsFont.TH.options"
                :getOptionLabel="getOptionLabelStyleFont"
                :disabled="true"
                :clearable="false"
              />
            </b-form-group>

            <div v-if="$store.getters['wallpapers/isEditMainImageOptionsFontStyle']('TH')">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : เลือกสไตล์ฟ้อน TH
                  </b-badge>
                </label>
                <v-select
                  v-model="wallpaperDatas.mainImage.oldOptionsFont.TH.style"
                  label="font"
                  :options="wallpaperDatas.mainImage.oldOptionsFont.TH.options"
                  :getOptionLabel="getOptionLabelStyleFont"
                  :disabled="true"
                  :clearable="false"
                />
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select font family EN -->
          <b-col md="6">
            <b-form-group label="เลือกฟ้อน EN" label-for="fontFamilyEN">
              <v-select
                v-model="wallpaperDatas.mainImage.optionsFont.EN.name"
                :options="paginated"
                label="family"
                @open="onOpen"
                @close="onClose"
                @search="query => (search = query)"
                :style="{ 'font-family': _fontActiveEN }"
                :disabled="true"
              >
                <template v-slot:option="option">
                  <span :class="option.icon"></span>
                  <div :style="{ 'font-family': option.family }">{{ option.family }}</div>
                </template>
                <template #list-footer>
                  <li v-show="hasNextPage" ref="load" class="loader">
                    <div class="d-flex justify-content-center mb-1 loader">
                      <b-spinner type="grow" variant="primary" />
                    </div>
                  </li>
                </template>
              </v-select>
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageOptionsFontStyle']('EN')">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : เลือกฟ้อน EN
                  </b-badge>
                </label>
                <v-select
                  v-model="wallpaperDatas.mainImage.oldOptionsFont.EN.name"
                  :options="[]"
                  label="family"
                  :style="{ 'font-family': _fontActiveEN }"
                  :disabled="true"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon" />
                    <div :style="{ 'font-family': option.family }">
                      {{ option.family }}
                    </div>
                  </template>
                </v-select>
              </b-form-group>
              <hr />
            </div>
          </b-col>

          <!-- select font style EN -->
          <b-col md="6">
            <b-form-group label="เลือกสไตล์ฟ้อน EN" label-for="fontStyleEN">
              <v-select
                v-model="wallpaperDatas.mainImage.optionsFont.EN.style"
                label="font"
                :options="wallpaperDatas.mainImage.optionsFont.EN.options"
                :getOptionLabel="getOptionLabelStyleFont"
                :disabled="true"
                :clearable="false"
              />
            </b-form-group>
            <div v-if="$store.getters['wallpapers/isEditMainImageOptionsFontStyle']('EN')">
              <b-form-group>
                <label>
                  <b-badge variant="danger">
                    ข้อมูลเดิม : เลือกสไตล์ฟ้อน EN
                  </b-badge>
                </label>
                <v-select
                  v-model="wallpaperDatas.mainImage.oldOptionsFont.EN.style"
                  :options="wallpaperDatas.mainImage.oldOptionsFont.EN.options"
                  label="font"
                  :style="{ 'font-family': _fontActiveEN }"
                  :disabled="true"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon" />
                    <div :style="{ 'font-family': option.family }">
                      {{ option.family }}
                    </div>
                  </template>
                </v-select>
              </b-form-group>
              <hr />
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <af-modal-list-image-widget ref="refAFModalListImageWidget" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { required, numeric, double } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    translationTabKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      numeric,
      double,
      options: [],
      optionsFontNameTH: [],
      optionsFontNameEN: [],
      localActiveFontTH: null,
      localActiveFontEN: null,
      loading: false,
      observer: null,
      limit: 20,
      search: '',
      optionJoinAffiliate: [
        { text: 'ใช่', value: true },
        { text: 'ไม่', value: false },
      ],
    }
  },
  async mounted() {
    this.options = await this.api.get('/api/admin/admin-topic-images?filterType=zodiac')
    const res = await this.api.get('api/customers/google-font/fetch')
    this.observer = new IntersectionObserver(this.infiniteScroll)
    // console.log('res', res)
    const { eng, thai } = JSON.parse(res)
    // console.log(thai)
    this.optionsFontNameTH = thai
    this.optionsFontNameEN = eng

    if (this.wallpaperDatas.mainImage.optionsFont.EN.name) {
      this.loadGoogleFontSrc([{ ...this.wallpaperDatas.mainImage.optionsFont.EN.name }])
    }

    if (this.wallpaperDatas.mainImage.optionsFont.TH.name) {
      this.loadGoogleFontSrc([{ ...this.wallpaperDatas.mainImage.optionsFont.TH.name }])
    }
  },
  computed: {
    ...mapState('wallpapers', ['wallpaperDatas']),
    filtered() {
      return this.optionsFontNameEN.filter(en => en.family.includes(this.search))
    },
    paginated() {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length
    },
    _fontActiveTH() {
      return this.wallpaperDatas.mainImage.optionsFont.TH.name?.family ?? null
    },
    _fontActiveEN() {
      return this.wallpaperDatas.mainImage.optionsFont.EN.name?.family ?? null
    },
  },
  methods: {
    async validateForm() {
      const validate = await this.$refs.form.validate()
      if (!validate) return false

      return true
    },
    async fetchGoogleFont(key) {
      if (!key) return

      this.wallpaperDatas.mainImage.optionsFont[key].style = null
      // this.wallpaperDatas.mainImage.optionsFont[key].options = null
      const fontName = this.wallpaperDatas.mainImage.optionsFont[key].name.family

      if (!fontName) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `โปรดระบุชื่อฟ้อน ${key}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
        return
      }
      this.loading = true

      const res = await this.api.post(
        'api/customers/google-font',
        {
          fontname: fontName,
        },
        false,
      )
      // console.log(`[RES]: fetchGoogleFont key = ${key}`, res)

      if (Array.isArray(res)) {
        this.wallpaperDatas.mainImage.optionsFont[key].options = res
        this.wallpaperDatas.mainImage.optionsFont[key].style = res.length > 0 ? { ...res[0] } : null
      } else {
        this.gDisplayToast(
          `ไม่พบสไตล์ฟ้อน ${key} ที่ชื่อ ${fontName}`,
          'โปรดเลือกฟ้อนอื่น หรือไม่ระบบจะใช้ default ฟ้อนแทน',
          'danger',
        )
      }

      this.loading = false
    },
    getOptionLabelStyleFont(option) {
      // console.log('option', option)
      const { font } = option
      return `${font}`.split('.')[0]
    },
    getFourVariants(variants) {
      const regularWeights = [...variants]
        .filter(v => Boolean(Number(v)))
        .map(v => `0,${v}`)
        .sort((a, b) => a - b)
      const italicWeights = [...variants]
        .filter(v => v.slice(3) === 'italic')
        .map(v => `1,${v.slice(0, 3)}`)
        .sort((a, b) => a - b)

      // console.log('regularWeights', regularWeights)
      // console.log('italicWeights', italicWeights)
      // return `${regularWeights.join(';')};${italicWeights.join(';')}`
      // fourFont.regular = regularWeights.
    },
    loadGoogleFontSrc(allFont) {
      // console.log('loadGoogleFontSrc')
      // <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet">
      for (let i = 0; i < allFont.length; i += 1) {
        const { family, variants } = allFont[i]
        const fontFormat = `${family}`.split(' ').join('+')
        const cssId = `google-font-${fontFormat}-all`
        const existingFontLoad = document.getElementById(cssId)
        if (existingFontLoad) {
          return
        }
        // console.log('load font', allFont)
        // console.log(fontFormat)
        // const fontWeight = this.getFourVariants(variants)
        // console.log('fontWeight', fontWeight)
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.id = cssId
        link.href = `https://fonts.googleapis.com/css2?family=${fontFormat}&display=swap`
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 20
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    getOptionsFonts() {
      return { optionsFontNameTH: this.optionsFontNameTH, optionsFontNameEN: this.optionsFontNameEN }
    },
    onClickMoreDetailsAllSubWallpaperPriceAF() {
      const localRevenueSharing = Number(this.wallpaperDatas.mainImage.revenue_sharing)
      const localAFCommissionRate = Number(this.wallpaperDatas.mainImage.affiliate.commission_rate)

      if (localAFCommissionRate <= 0) {
        this.gDisplayToast('โปรดระบุอัตราค่าคอมมิชชั่นก่อน Affiliate', '', 'danger')
        return
      }

      const listSubWall = this.wallpaperDatas.allImage.map(v => {
        const { price, title_translations } = v.options

        return { name: title_translations?.th, price, urlPreview: v.file?.previewUrl || '' }
      })

      this.$refs.refAFModalListImageWidget.show(listSubWall, localRevenueSharing, localAFCommissionRate)
    },
  },
  watch: {
    'wallpaperDatas.mainImage.optionsFont.TH.name': function(newValue) {
      // console.log(newValue)

      if (newValue === null) {
        this.wallpaperDatas.mainImage.optionsFont.TH.style = null
        this.wallpaperDatas.mainImage.optionsFont.TH.options = []
        return
      }
      this.fetchGoogleFont('TH')
    },
    'wallpaperDatas.mainImage.optionsFont.EN.name': function(newValue) {
      // console.log('newValue', newValue)
      if (newValue === null) {
        this.wallpaperDatas.mainImage.optionsFont.EN.style = null
        this.wallpaperDatas.mainImage.optionsFont.TH.options = []
        return
      }
      this.fetchGoogleFont('EN')
    },
  },
}
</script>

<style lang="scss" scoped></style>
